<template>
  <div style="position: relative; height: 100%;">
    <component
      v-if="!dataError"
      :is="visualizationToUse.componentName"
      ref="visualization_type"
      :resize-trigger="resizeTrigger"
      :show-loading="false"
      :stations="stations"
      :data="transformedData"
      :customOptions="visualizationToUse.customOptions"
      :seriesOptions="{}"
      :visualizationOptions="visualizationConfig.options"
      :grid-max-cols="gridMaxCols"
      :grid-width="gridWidth"
      :grid-x="gridX"
      :uom-units="uomUnits"
    />

    <cc-error :show="dataError" style="padding: 20px;" @click="$emit('reloadClicked')"></cc-error>

    <div v-if="dataLoading" class="visualization-info-container">
      <div class="visualization-info-box">
        <div style="width: 40px; text-align: center; padding: 10px 0;">
          <b-spinner variant="success" style="height: 20px; width: 20px;"></b-spinner>
        </div>
      </div>
    </div>

    <div
      v-if="!dataLoading && !dataError && data.length < totalMeasurementsMatched"
      class="visualization-info-container"
    >
      <div class="visualization-info-box">
        <div style="width: 40px; text-align: center; font-size: 20px; line-height: 1; padding: 5px 0;">
          <div
            v-b-tooltip.hover
            :title="$t('dashboard:panel.too_many_measurements', { defaultValue: 'A panel can only display {{max}} measurements. Some matched measurements are hidden.', max: 20 })"
            class="too-many-measurements-warning"
          >
            <i class="fa fa-exclamation-triangle text-warning"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.visualization-info-container {
  max-width: 100%;
  overflow: hidden;
  position: absolute;
  top: 0px;
  right: 0px;
}
.visualization-info-box {
  position: relative;
  display: flex;
  justify-content: center;
  top: 0px;
  right: 0px;
  background: white;
  margin: 10px;
  box-shadow: 0px 0px 4px -1px black;
  border-radius: 4px;
  overflow: hidden;
}
.too-many-measurements-warning {
  padding: 5px;
  display: inline-block;
  border-radius: 4px;
}
.too-many-measurements-warning:hover {
  background-color: #fff6cc;
}
</style>

<script>
import VISUALIZATION_TYPES from '@/shared/visualization-types.js';

const componentObj = {};
for (let visType of VISUALIZATION_TYPES) {
  componentObj[visType.componentName] = visType.component;
}

export default {
  name: 'visualization',

  components: componentObj,

  props: {
    color: {
      type: String,
    },
    visualizationConfig: {
      type: Object,
    },
    resizeTrigger: {
      type: Boolean,
    },
    stations: {
      type: Array,
    },
    gridMaxCols: {
      type: Number,
    },
    gridWidth: {
      type: Number,
    },
    gridX: {
      type: Number,
    },
    data: {
      type: Array,
    },
    dataLoading: {
      type: Boolean,
    },
    dataError: {
      type: Boolean,
    },
    uomUnits: {
      type: Array,
      default: [],
    },
    totalMeasurementsMatched: {
      type: Number,
    },
  },

  data() {
    return {};
  },

  computed: {
    visualizationToUse() {
      return VISUALIZATION_TYPES.find(e => e.id === this.visualizationConfig.type);
    },
    transformedData() {
      return this.visualizationToUse.dataTransformer(this.data.map(e => {
        return {
          key: e.station + ' : ' + e.measurement,
          ...e,
        };
      }));
    },
  },

  watch: {},

  mounted() {},
}
</script>